import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Divider, Flex, Menu, MenuButton, MenuItem, Text } from '@aws-amplify/ui-react'
import { BiUser } from 'react-icons/bi'
import { Logo } from './static/Logo'

export interface MobileNavProps {
    authStatus: string
    userDisplayName: string
    onSignOut: () => void
}

export function MobileNav({ authStatus, userDisplayName, onSignOut }: MobileNavProps) {
    const navigate = useNavigate()

    return (
        <Flex
            className="mobile-nav"
            justifyContent="space-between"
            alignItems="center"
            padding="0.5rem"
            width="100%"
        >
            {/* Left side: Logo + hamburger menu */}
            <Flex alignItems="center" gap="0">
                <Logo />
                <Menu
                    trigger={
                        <MenuButton size="small" aria-label="Navigation menu">
                            ☰
                        </MenuButton>
                    }
                >
                    <MenuItem onClick={() => navigate('/pricing')}>Pricing</MenuItem>
                    <Divider />
                    <MenuItem onClick={() => navigate('/doc')}>Documentation</MenuItem>
                    <MenuItem onClick={() => navigate('/faq')}>FAQ</MenuItem>
                    <MenuItem onClick={() => navigate('/issue')}>Issue</MenuItem>
                    <MenuItem onClick={() => navigate('/support')}>Support</MenuItem>
                    <Divider />
                    <MenuItem onClick={() => navigate('/contribute')}>Contribute</MenuItem>
                    <MenuItem onClick={() => navigate('/makemoney')}>Make Money</MenuItem>
                </Menu>
            </Flex>

            {/* Right side: Account menu — show user icon instead of email on mobile */}
            {authStatus !== 'authenticated' ? (
                <Button size="small" onClick={() => navigate('/login')}>Sign In</Button>
            ) : (
                <Menu
                    trigger={
                        <MenuButton size="small" aria-label="Account menu">
                            <BiUser size={18} />
                        </MenuButton>
                    }
                >
                    <MenuItem isDisabled={true}>
                        <Text fontSize="small" color="font.tertiary">{userDisplayName}</Text>
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={() => navigate('/referral')}>Referral Program</MenuItem>
                    <MenuItem onClick={() => navigate('/password')}>Password Change</MenuItem>
                    <MenuItem variation="warning" onClick={onSignOut}>
                        <Text variation="warning">Logout</Text>
                    </MenuItem>
                    <Divider />
                    <MenuItem variation="destructive" onClick={() => navigate('/unregister')}>
                        <Text variation="error">Delete Account</Text>
                    </MenuItem>
                </Menu>
            )}
        </Flex>
    )
}
